<template>
    <confirmation-dialog
        :show="showDialog"
        title=""
        :proceed-button-text="nextButtonText"
        @proceed="nextSection()"
        :showProceedButton="showNextButton"
        cancel-button-text="Previous"
        @cancelled="previousSection()"
        :showCancelButton="showPreviousButton">
        <div slot="icon"></div>
        <div slot="header"></div>
        <div slot="title"></div>
        <div slot="subtitle"></div>
        <div class="outline-none" slot="body" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="flex justify-center" style="min-height: 420px" role="document">
                <div v-show="currentSection(1)">
                    <h4 class="text-lg font-medium text-indigo-600 mt-3 p-2 flex justify-center">{{ currentDay | date }}</h4>
                    <div class="flex justify-center" style="min-height: 235px">
                        <img class="w-1/2" src="/images/animat-rocket-color.gif">
                    </div>
                    <p class="text-lg">
                        This is the date your job got a lot easier and seriously more organized! We built
                        <b>RedRabbit</b> to help companies like yours and people like you manage maintenance and
                        inspections and improve their productivity. We hope that we can achieve that for you.
                    </p>
                </div>
                <div v-show="currentSection(2)">
                    <h4 class="text-lg font-medium text-indigo-600 mt-3 p-2 flex justify-center">You're not alone</h4>
                    <div class="flex justify-center mb-7 mt-1" style="min-height: 180px">
                        <img class="w-1/2" src="/images/support-animation.gif">
                    </div>
                    <p class="text-lg">
                        We're all about making sure you're successful. If you ever need any help or simply want
                        to chat about the things tenants do, feel free to send us a mail to <a
                        class="font-medium" href="mailto:info@redrabbit.zone">info@redrabbit.zone</a>
                        or call us on <b class="font-medium">021 913 6107</b>. If you prefer <b>instant
                        answers</b> check out our knowledge base: <a class="font-medium" href="https://help.redrabbit.zone">help.redrabbit.zone</a>
                    </p>
                </div>
                <div v-show="currentSection(3)">
                    <h4 class="text-lg font-medium text-indigo-600 mt-3 p-2 flex justify-center">Ready to explore?</h4>
                    <div class="flex justify-center mt-1 text-center"  style="min-height: 235px">
                        <img class="w-1/2" src="/images/animat-sailboat-color.gif">
                    </div>
                    <p class="text-lg">
                        We have a variety of features for you to explore and are excited to have you on board!
                    </p>
                </div>
            </div>
        </div>
    </confirmation-dialog>
</template>

<script>
export default {
    name: "WelcomeModal",
    data () {
        return {
            showDialog: false,
            showPreviousButton: false,
            showNextButton: true,
            nextButtonText: "Next",
            currentDay: moment.now(),
            onboardingSection: 1
        };
    },

    mounted () {
        this.showDialog = true;
    },

    methods: {
        currentSection (section) {
            return this.onboardingSection === section;
        },

        nextSection () {
            this.onboardingSection += 1;
            this.showPreviousButton = this.onboardingSection > 1;
            this.showNextButton = this.onboardingSection <= 3;
            this.setNextButtonText(this.onboardingSection);
            // When they click Explore
            this.onboardingSection === 4 ? this.explore("dashboard") : null;
        },

        setNextButtonText (section) {
            this.nextButtonText = section === 3 ? "Explore" : "Next";
        },

        previousSection () {
            this.onboardingSection -= 1;
            this.showPreviousButton = this.onboardingSection !== 1;
            this.showNextButton = this.onboardingSection > 0;
            this.setNextButtonText(this.onboardingSection);
        },

        explore (topic) {
            if (topic === "dashboard") {
                this.showDialog = false;
            }

            axios.post("/home/explore", {topic: topic});
        }
    }
};
</script>

<style scoped>
</style>
